<template>
  <div class="page">
    <div class="locations-grey locations-generic employ">
      <section>
        <strong>Best Job in the World &ndash; and we're Hiring.</strong> 
      </section>
 Part-time, April through
October. Must have excellent customer service skills and a heck of a lot of
stamina. It's hard work! 
<br /><br />
As we are a seasonal business, employees will be expected to work Father's Day/Juneteenth, Independence Day, and Labor Day. Preference given to applicants who have
availability through the end of the season. Interested?<br /><br />
Email Liam Durnan: <a href="mailto:Liam@ChicagoRiverPaddle.com">Liam@ChicagoRiverPaddle.com</a> 
  </div>
  </div>
</template>

<script>
export default {
  name: 'Employment',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.employ {
width: 50%;
align-self: center;
}
.page {
  background-image: url("../../assets/psemployment.png");
  flex-direction: column;
  padding-left: 20px;
}
section {
  margin-bottom: 10px;
}
a:hover {
  color: #9f001c !important;
}
a {
  color: white;
}
@media screen and (max-width: 768px) {
  .employ {
    width: 90%;
  }
}
</style>
